var uploadIconHover = "/home/circleci/app/src/assets/img/uploadIconHover.svg";

export { uploadIconHover as default };
